import { useFeatureFlagEnabled } from '@posthog/react';

import { EFeatureFlags } from '@/types';

export const useFeatureFlag = (featureFlag: EFeatureFlags): boolean => {
  const flag = useFeatureFlagEnabled(featureFlag);

  return flag ?? false;
};
